import cn from 'clsx'

import { NavLink, Button, ImageBox } from 'shared-components'

import { getSanityLink } from 'shared-functions'

import s from './Item.module.sass'

function Item({ item }: any) {
    const { year, awardStatus, subtitle, title, image, copy, link, download } = item

    const _link = download?.asset?.url
        ? download?.asset?.url
        : link?.linkType === 'internal' || link?.linkType === 'external'
          ? getSanityLink(link) || null
          : null

    const content = (
        <>
            {year && <span className={cn(s.Year, 'smallCaps')}>{year}</span>}
            {awardStatus && <span className={cn(s.AwardStatus, 'smallCaps')}>{awardStatus}</span>}
            <div className={s.Main}>
                {subtitle && <div className={cn(s.Subtitle, 'smallCaps')}>{subtitle}</div>}
                {title && <div className={s.Title}>{title}</div>}
                {copy && <p className={cn(s.Copy, 'copy small')} dangerouslySetInnerHTML={{ __html: copy }} />}
            </div>
            {image && (
                <div className={s.Image}>
                    <ImageBox image={image} />
                </div>
            )}
        </>
    )

    return (
        <div className={s.Item}>
            {_link ? (
                <NavLink className={download?.asset?.url ? s.Download : s.Link} href={_link?.url || _link || ''}>
                    {content}
                    <Button
                        title={download?.asset?.url ? 'Download' : link?.title || ''}
                        className={s.Button}
                        noArrow={download?.asset?.url}
                    />
                </NavLink>
            ) : (
                <div className={s.Inner}>{content}</div>
            )}
        </div>
    )
}

export default Item
